import React from 'react'

const RefundPage = () => {
  return (
    <div>
        Product Refund Page
    </div>
  )
}

export default RefundPage
